import conditions from './conditions';
import disasters from './disasters';
import authorities from './authorities';
import areas from './areas';
import dates from './dates';
import prefectures from './prefectures';
import intensities from './intensities';
import answers from './answers';
import injuries from './injuries';
import plan from './plan';
import gender from './gender';

export default {
  conditions,
  disasters,
  authorities,
  areas,
  dates,
  prefectures,
  intensities,
  answers,
  injuries,
  plan,
  gender,
};
